import { ApiError } from "@jobenvoy/core";

/** How many times a read is tried again after it fails for a reason that may pass. */
export const READ_RETRIES = 2;

/**
 * Whether a failed read is worth trying again. A refusal (a 4xx) will be
 * refused again, so it is shown at once: a missing posting says so
 * without seven seconds of "Reading…". A timeout or a rate limit, a
 * server error and a dropped connection may pass, and are tried again.
 */
export function shouldRetry(failureCount: number, error: unknown): boolean {
    if (failureCount >= READ_RETRIES) return false;
    if (error instanceof ApiError) {
        const refused = error.status >= 400 && error.status < 500;
        return !refused || error.status === 408 || error.status === 429;
    }
    return true;
}
